import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatExpensesAreYouClaimingFor: [],

    // Doctor Visit fields
    doctorVisitTelemedicine: '',
    doctorVisitFirstVisit: '',
    doctorVisitFollowUp: '',
    doctorVisitFollowUpFracture: '',
    infoTelemedicineItems: [],
    infoOutpatientPhysicianFeesItems: [],
    infoFollowUpVisitItems: [],
    infoFollowUpFractureItems: [],

    // Diagnostic Tests fields
    infoDiagnosticTestsItems: [],

    // Prescription Drugs fields
    infoPrescriptionDrugsItems: [],

    // Ambulance Services fields
    ambulanceGroundService: '',
    ambulanceAirService: '',
    infoGroundAmbulanceItems: [],
    infoAirAmbulanceItems: [],

    // Hospitalization fields
    hospitalizationHospitalInvoice: '',
    hospitalizationPhysicianInvoice: '',
    hospitalizationLabDiagnostic: '',
    hospitalizationOtherRelated: '',
    infoHospitalFeesItems: [],
    infoInpatientPhysicianFeesItems: [],
    infoXrayLabsDiagnosticsItems: [],
    infoOtherHospitalizationItems: [],

    // Essential Medical Appliances fields
    infoEssentialMedicalAppliancesItems: [],

    // Private Duty Nursing fields
    infoPrivateDutyNursingItems: [],

    // Fracture Treatment fields
    infoFractureTreatmentItems: [],

    // Other Unrelated Benefit fields
    infoOtherUnrelatedBenefitItems: [],
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  // Only reset the specified fields to empty arrays or default values
  let newState = state;
  fields.forEach((field) => {
    // Get the default value from initialState for this field
    const defaultValue = initialState.getIn(['form', field]);
    // Reset the field to its default value (empty array [] or empty string '')
    newState = newState.setIn(['form', field], defaultValue);
  });

  return newState;
}

function baseVictorsMedicalTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default baseVictorsMedicalTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaseVictorsMedical/reducer.js